import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

// Définition de la requête GraphQL
const GET_CONSULTANT_STATEMENT = gql`
  query GetConsultantStatement($year: Int!, $consultantUuid: ID!) {
    consultantStatement(statementRequest: { year: $year, consultantUuid: $consultantUuid }) {
      dailyRateClient
      dailyRateConsultant
      daysSick
      daysWorked
      employeeContributions
      employerCost
      employerContributions
      expenses
      grossSalary
      companyBenefit
      netSalary
      overflow
      netMargin
      taxes
      year
      otherOperations
      otherOperationsCredit
      otherOperationsDebit
      initialization
      interestsPayment
      investments
      investmentsCredit
      investmentsDebit
      statementMonths {
        consultantServiceAmount
        cooptation
        currency
        dailyRateClient
        dailyRateConsultant
        daysSick
        daysWorked
        employeeContributions
        employerCost
        employerContributions
        employerCostExclBonus
        expenses
        grossSalary
        companyBenefit
        month
        netSalary
        commission
        overflow
        overflowBalance
        overflowDebit
        overflowCredit
        taxes
        uuid
        otherOperations
        otherOperationsCredit
        otherOperationsDebit
        initialization
        interestsPayment
        investments
        investmentsCredit
        investmentsDebit
        cooptations {
          amount
          cooptedName
          cooptedUuid
          currency
          percentage
          uuid
        }
      }
    }
  }
`;

const useConsultantStatement = (year, consultantUuid, skip = false) => {

    const  { data, loading, error, refetch } = useQuery(GET_CONSULTANT_STATEMENT, {
        variables: { year, consultantUuid },
        skip: skip || !year || !consultantUuid, // ✅ Skip si pas d'année ou de consultant
    });

    return {
        data: data?.consultantStatement || null,
        loading,
        error,
        refetch,
    };
};

export default useConsultantStatement;
